<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-31 15:33:31
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 11:38:01
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\shopList\components\inviteDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" :before-close="beforeClose" width="400px">
		<div slot="title"></div>
		<div class="align-center pb-10">
			<img src="@/assets/public/collaboration-invitation.png" alt="" style="width: 96px; height: 96px" />
			<p class="mt-20 yx-color-text-primary font-h3-medium">协作邀请</p>
			<p class="yx-color-text-secondary font-h6-regular">发送协作邀请商家协助样品订单审核/发货，节省线下来回沟通整理</p>
			<p class="yx-color-text-secondary font-h6-regular">excel表格的时间；招商+店铺维度仅支持存在1个启用状态的协作商</p>
			<p class="yx-color-text-secondary font-h6-regular">家账号</p>
			<el-tooltip placement="top" :content="link" v-ak-tooltip-auto-show>
				<div class="link yx-color-text-primary font-h4-regular mt-24 radius-4 mb-20 line-ellipsis-1" style="width: calc(100% - 24px)">
					{{ link }}
				</div>
			</el-tooltip>
			<el-button type="primary" @click="copyLink">复制邀请链接</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { copy } from '@/utils/common';
import { cooperativeShopGetLink } from '@/api/cooperativeShop';
export default {
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
		teamName: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			visible: false,
			link: '',
			authorityIds: [],
			params: {},
		};
	},
	methods: {
		show(params) {
			this.params = params;
			this.getLink();
			this.visible = true;
		},
		async getLink() {
			const { platformId } = this;
			const { outerShopId, authorityIds } = this.params;
			const { shareLink = '' } = await cooperativeShopGetLink({ platformId, outerShopId, authorityIds });
			this.link = shareLink;
		},
		copyLink() {
			let str = `${this.teamName}邀请您使用商团协作工具【热度云（友情版）】，免费享受团长申样微信提醒、同步样品订单、获取物流轨迹、交付数据统计等功能提高协同效率，请登录 ${this.link}`;
			copy(str);
			this.$message.success('复制成功！');
		},
		beforeClose() {
			this.outerShopId = '';
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__header {
	border: none;
}
.link {
	padding: 0px 12px;
	height: 40px;
	line-height: 40px;
	background-color: #f7f8fa;
	border: 1px solid #e2e3e8;
}
</style>
